import React, { useState, useMemo } from 'react';
import { Modal, Card, Button } from 'antd';
import PropTypes from 'prop-types';
import './StartMCQ.modal.css';
import jwt from 'jsonwebtoken';
import SkillEditor from '../../shared/SkillEditor/SkillEditor';
import InStackDemandSelector from '../../shared/InStackDemandSelector/InStackDemandSelector';
import InStackDemandOtherSelector from '../../shared/InStackDemandOtherSelector/InStackDemandOtherSelector';
import { connect } from 'react-redux';
import ProfileEditLockInfo from '../../../components/common/ProfileEditLockInfo';
import SectionTitle from '../../shared/SectionTitle/RenderSectionTitle';

function SkillsEditorModal (props) {
  const { visible, /* onCancel, */ onOk, use_onboarding_improved_ui_ux_multi_variant } = props;
  // const [skillEditorData, setSkillEditorData] = useState(null);
  const token = localStorage.getItem('token');
  const handleAllSkills = (args) => {
    const data = Object.assign({}, args);
    if (data) {
      if (data.topSkills) data.topSkills = data.topSkills.filter(item => item.skill_id);
      if (data.allSkills) data.allSkills = data.allSkills.filter(item => item.skill_id);
    }
    // setSkillEditorData(data);
  };

  const [skillError, setSkillError] = useState(false);
  const [roleChangeDetected, setRoleChangeDetected] = useState(false);
  const handleClose = callback => () => {
    const skillErr = props.skillEditor && props.skillEditor.validation_error && props.skillEditor.validation_error.message && props.skillEditor.validation_error.message !== '';
    setSkillError(skillErr);
    if (!skillErr && callback) callback();
    if (roleChangeDetected) {
      window.dispatchEvent(new Event('vetting-refresh'));
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleClose(onOk)}
      footer={<Button type="primary" onClick={handleClose(onOk)}>Done</Button>}
      width={use_onboarding_improved_ui_ux_multi_variant === 'v1' ? 700 : 400}
      className="turing-ui-v2-mcq-modal"
      bodyStyle={{ padding: 0, margin: 0 }}
      destroyOnClose
      centered
    >
      <div className="turing-ui-v2-start-mcq-modal-container">
        <Card>
          {
            use_onboarding_improved_ui_ux_multi_variant === 'v1' ? (
              <>
                <div className="details-card">
                  <SectionTitle
                    title={<span>Here are the Top 70% of the tech stacks we are hiring for.<br/>Which one(s) are you professionally good at?</span>}/>
                  <small className="sub-SectionTitle">Select all that apply</small>
                  <InStackDemandSelector roleChangeDetected={setRoleChangeDetected}/>
                  <InStackDemandOtherSelector onClose={handleClose(onOk)}/>
                </div>
                <br/>
              </>
            ) : (
              <SectionTitle
              title={<span>Select skills that you are professionally good at.</span>}/>
            )
          }
            <SkillEditor userId={jwt.decode(token) && jwt.decode(token).uid} handleAllSkills={handleAllSkills} hideTitle showEr={!!skillError}/>
        </Card>
      </div>
    </Modal>
  );
}

SkillsEditorModal.propTypes = {
  visible: PropTypes.any,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  skillEditor: PropTypes.object,
};

const mapStateToProps = appState => ({
  skillEditor: appState.skillEditor
});

export default connect(mapStateToProps)(SkillsEditorModal);
